export const images = {
  logo: '/images/logo.svg',
  logoText: '/images/logo/logo-text.png',
  // Los assets dark/light específicos fueron eliminados en la limpieza de logos.
  // Todas las variantes apuntan al logo base; la adaptación al tema se maneja vía CSS.
  logoDark: '/images/logo.svg',
  logoDarkText: '/images/logo/logo-text.png',
  logoLight: '/images/logo.svg',
  logoLightText: '/images/logo/logo-text.png',
};
